'use client';

import { useEffect } from 'react';

const TOPSORT_TOKEN = process.env.NEXT_PUBLIC_TOPSORT_TOKEN || '';

export default function TopsortConfigBody() {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      if (!window.TS?.token) {
        window.TS = {
          ...(window.TS || {}),
          token: TOPSORT_TOKEN
        };
      }
    }
  }, [TOPSORT_TOKEN]);
  return null;
}
